import React from "react";
import { logoDark } from "../../assets/images";
import FooterIcon from "./FooterIcon";

const Footer = () => {
  return (
    <div className="w-full bg-black text-gray-200 py-10">
      <div className="max-w-screen-xl mx-auto flex flex-col justify-center items-center gap-4">
        <div>
          <img className="w-60" src={logoDark} alt="logoDark" />
        </div>
        <div>
          <FooterIcon />
        </div>
        <div>
          <a href="https://www.reactbd.com/license">
            <p className="text-sm text-gray-500 tracking-wider px-4 text-center hover:text-white duration-300 cursor-pointer">
              © Copyright 2026 by Reactbd. All rights reserved.
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
